const initialState = (value, latinValue) => {
  return {
    value: value,
    latinValue: latinValue,
    sameValues: checkSameValues(value, latinValue)
  }
}

const actionTypes = {
  setValue: 'setValue',
  setLatinValue: 'setLatinValue',
  setSameValue: 'setSameValue'
}

function reducer (state = initialState, action) {
  switch (action.type) {
    case actionTypes.setValue:
      return state.sameValues ? { ...state, value: action.data, latinValue: action.data } : { ...state, value: action.data }
    case actionTypes.setLatinValue:
      return { ...state, latinValue: action.data }
    case actionTypes.setSameValue:
      return { ...state, sameValues: action.data, latinValue: state.value }
  }
}

function checkSameValues (value, latinValue) {
  return (!latinValue || value === latinValue)
}

export {
  actionTypes,
  initialState,
  reducer
}



// WEBPACK FOOTER //
// ./src/dialogs/userRow/reducer.js